export default __webpack_public_path__ + "static/media/farfetch.ad79a03f.png";